/* eslint-disable no-unused-vars */
import { useId, memo, useRef, useMemo } from 'react';
import { Buttons, CampaignReportChangeCols } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import { ColumnsIcon } from 'assets/icons';
import { campaignReportsActions } from 'store/actions';
import { useSignal } from '@preact/signals-react';

const btnCustomOpen = {
  color: 'rgb(59, 137, 246)', // primary_500
  marginRight: '8px',
};

export const ColumnsBtn = ({ dateFrom$, dateTo$ }) => {
  const columnsBtnId = useId();

  const isOpen$ = useSignal(false);
  return (
    <div>
      <Buttons.QuaternaryNormal
        id={columnsBtnId}
        icon={<ColumnsIcon />}
        isPressed={isOpen$.value}
        style={isOpen$.value ? btnCustomOpen : { marginRight: '8px' }}
        onClick={() => (isOpen$.value = true)}
      >
        Columns
      </Buttons.QuaternaryNormal>
      {isOpen$.value && (
        <CampaignReportChangeCols isOpen$={isOpen$} dateFrom$={dateFrom$} dateTo$={dateTo$} />
      )}
    </div>
  );
};
